import { createAsyncThunk } from '@reduxjs/toolkit';
import jobStatusApi from '~/apis/job-status';

import { CREATE_JOB_STATUS, EDIT_JOB_STATUS, GET_JOB_STATUS, GET_JOB_STATUSES } from '~/utils/constants/actionType';

import { IJobStatus, IParamsGetJobStatus, IResponseGetJobStatus, IUpdatePosition } from '~/utils/interface/job-status';

export const handleCreateJobStatus = createAsyncThunk<IJobStatus, IJobStatus>(
  CREATE_JOB_STATUS,
  async (data: IJobStatus, { rejectWithValue }) => {
    try {
      const res = await jobStatusApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetJobStatuses = createAsyncThunk<IResponseGetJobStatus, IParamsGetJobStatus>(
  GET_JOB_STATUSES,
  async (params: IParamsGetJobStatus = {}, { rejectWithValue }) => {
    try {
      const res = await jobStatusApi.getList(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetJobStatus = createAsyncThunk<IJobStatus, string>(
  GET_JOB_STATUS,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await jobStatusApi.getDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleEditJobStatus = createAsyncThunk<IJobStatus, { id: string; params: IJobStatus }>(
  EDIT_JOB_STATUS,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await jobStatusApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateposition = createAsyncThunk<IJobStatus, { id: string; params: IUpdatePosition }>(
  'UPDATE_POSITION',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await jobStatusApi.updatePosition(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
